import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 18v-12h4a4 4 0 0 1 4 4v4","key":"svg-0"}],["path",{"d":"M18 6v12h-4a4 4 0 0 1 -4 -4v-4","key":"svg-1"}]]

const IconCurrencyShekel = createReactComponent('outline', 'currency-shekel', 'CurrencyShekel', __iconNode);

export default IconCurrencyShekel;